import {Component} from 'react';


class TrainBetweenTurns extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: true,
           };
    }

    render() { 
      
    return <>
        <div className="trainPosition">
            <img src="./assets/Events/MoneyTrainReverse.png"
                onAnimationEnd={this.props.trainVideoDone()}
                className="money-train-info move-train-on-track" alt="moneyTrain" />
            <img src="./assets/Events/TrainMovingBackground.jpg"
                className="train-end-of-turn" alt="trainStationTrack" />
            <div className="decorative begin-month-text text-white 
                font-weight-bold">{this.props.prevMonth}</div>
            <div className="decoratve end-month-text text-white 
                font-weight-bold">{this.props.currentMonth}</div>
        </div>
    </>
    }
  
}
 
export default TrainBetweenTurns;